/** SessionStorage key for Clarity user ID so we can identify on next load before session API returns */
export const CLARITY_USER_ID_STORAGE_KEY = 'clarity_user_id'

/** SessionStorage key for Clarity internal user tag (e.g. @artem.earth) so we can set it on restore */
export const CLARITY_ARTEM_ADMIN_KEY = 'clarity_artem_admin'

/** SessionStorage key for PPWR supplier portal Clarity user ID (packaging supplier id) */
export const CLARITY_SUPPLIER_PORTAL_USER_ID_STORAGE_KEY =
  'clarity_supplier_portal_user_id'
